export const GET_SUB_TRADES = 'sub_trades/GET_SUB_TRADES'
export const GET_SUB_TRADE = 'sub_trades/GET_SUB_TRADE'
export const ADD_SUB_TRADES = 'sub_trades/ADD_SUB_TRADES'
export const EDIT_SUB_TRADES = 'sub_trades/EDIT_SUB_TRADES'
export const DELETE_SUB_TRADE = 'sub_trades/DELETE_SUB_TRADE'
export const GET_LOCKED_SUB_TRADES = 'sub_trades/GET_LOCKED_SUB_TRADES'
export const START_LOADING_SUB_TRADES = 'sub_trades/START_LOADING_SUB_TRADES'
export const STOP_LOADING_SUB_TRADES = 'sub_trades/STOP_LOADING_SUB_TRADES'
export const ADD_SUB_TRADE_FEE = 'sub_trades/ADD_SUB_TRADE_FEE'
export const EDIT_SUB_TRADE_FEE = 'sub_trades/EDIT_SUB_TRADE_FEE'
export const ADD_LOCKED_SUB_TRADE_FEE = 'sub_trades/ADD_LOCKED_SUB_TRADE_FEE'
export const EDIT_LOCKED_SUB_TRADE_FEE = 'sub_trades/EDIT_LOCKED_SUB_TRADE_FEE'
export const DELETE_SUB_TRADE_FEE = 'sub_trades/DELETE_SUB_TRADE_FEE'
export const CHANGE_ALLOCATION_SUB_TRADE =
  'sub_trades/CHANGE_ALLOCATION_SUB_TRADE'
export const CHANGE_WIRE_INSTRUCTION_SUB_TRADE =
  'sub_trades/CHANGE_WIRE_INSTRUCTION_SUB_TRADE'
export const ADD_TEMPORARY_SUB_TRADE = 'sub_trades/ADD_TEMPORARY_SUB_TRADE'
export const UPDATE_SUB_TRADE_CLIENT_ID =
  'sub_trades/UPDATE_SUB_TRADE_CLIENT_ID'
export const SETTLE_SUB_TRADE = 'sub_trades/SETTLE_SUB_TRADE'
export const UNSETTLE_SUB_TRADE = 'sub_trades/UNSETTLE_SUB_TRADE'
export const TERMINATE_SUB_TRADE = 'sub_trades/TERMINATE_SUB_TRADE'
